import React from 'react';

// === Components === //
import Container from '@components/common/Container';
import Paragraph from '@components/common/Paragraph';

// === Styles === //
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { breakpoints, respondFrom, respondTo } from '@styles';

// === Types === //
import { Variant } from '@content/types/layout';
import Title from './Title';

const ImageWithTextWrapper = styled.div<ReverseProps>`
  display: flex;
  flex-flow: ${(props) => (props.reverse ? 'row-reverse' : 'row')};
  margin-top: -30px;

  ${respondTo(
    breakpoints.md,
    css`
      flex-flow: column;
      padding: 0;
    `
  )};

  &.with-title {
    align-items: center;
    margin: 60px 0;
  }
`;

const ParagraphWrapper = styled.div`
  flex: 1;

  ${respondTo(
    breakpoints.lg,
    css`
      text-align: left;
      margin: 0 auto;
    `
  )}

  ${respondTo(
    breakpoints.md,
    css`
      width: 100%;
      text-align: left;
    `
  )}
`;

const ImageWrapper = styled.div<ReverseProps>`
  padding: 0;
  margin: 30px auto;
  text-align: center;

  ${(props) =>
    respondFrom(
      breakpoints.md,
      css`
        padding-left: ${props.reverse ? '0' : '40px'};
        padding-right: ${props.reverse ? '80px' : '0'};
        margin: auto;
      `
    )}

  ${(props) =>
    respondFrom(
      breakpoints.lg,
      css`
        padding-left: ${props.reverse ? '0' : '90px'};
        padding-right: ${props.reverse ? '130px' : '0'};
      `
    )}

  &.hide-on-desktop {
    ${respondFrom(
      breakpoints.md,
      css`
        display: none;
      `
    )}
  }

  &.hide-on-mobile {
    ${respondTo(
      breakpoints.md,
      css`
        display: none;
      `
    )}
  }
`;

const Image = styled.img`
  max-width: 100%;
`;

interface ImageWithTextProps {
  src: string;
  alt: string;
  text: string;
  title: string;
  variant: Variant;
  reverse?: boolean;
}

interface ReverseProps {
  reverse: boolean;
}

const ImageWithText = ({ src, alt, text, title, variant, reverse = false }: ImageWithTextProps) => {
  return (
    <Container>
      <ImageWithTextWrapper reverse={reverse} className={title && title !== '' ? 'with-title' : ''}>
        <ParagraphWrapper>
          {title && title !== '' && (
            <>
              <Title text={title} variant={variant} alignRight={false} noMarginTop={true} />
              <ImageWrapper reverse={reverse} className="hide-on-desktop">
                <Image src={src} alt={alt}></Image>
              </ImageWrapper>
            </>
          )}
          <Paragraph text={text} variant={variant}></Paragraph>
        </ParagraphWrapper>
        <ImageWrapper reverse={reverse} className={title && title !== '' ? 'hide-on-mobile' : ''}>
          <Image src={src} alt={alt}></Image>
        </ImageWrapper>
      </ImageWithTextWrapper>
    </Container>
  );
};

export default ImageWithText;
